<router-outlet *ngIf="usePlaceHolder == false"></router-outlet>

<!-- documentPlaceHolder utilizzato per sostituire il contenuto -->
<ng-template #documentPlaceHolder></ng-template>